$(document).ready(function () {

  dayjs.extend(dayjs_plugin_utc);
  dayjs.extend(dayjs_plugin_timezone);

  // Check if #promotime exists and has text content
  let promoTimerText = $('#countdowntime').text().trim();

  //console.log("Here is the countdown timer for announcement bar");
  //console.log(promoTimerText);

  if (promoTimerText) {
    promoTimerText = promoTimerText.replace(/[^\d: /]/g, '');
    
    try {
      // Split the string based on the '/' separator to get start and end dates
      const promoTimer = promoTimerText.split('/');

      // Convert start and end dates using Day.js with timezone
      const startDate = dayjs.tz(promoTimer[0], "YYYY-M-D HH:mm:ss", "America/Los_Angeles");
      const endDate = dayjs.tz(promoTimer[1], "YYYY-M-D HH:mm:ss", "America/Los_Angeles");

      function updateCountdown() {
        // Get the current date and time in PST
        var now = dayjs().tz("America/Los_Angeles");

        // Check if the current time is before the start time
        if (now.isBefore(startDate)) {
          $('.announcement_timer').html("Sale starts soon!");
          return;
        }

        // Check if the current time is after the end time
        if (now.isAfter(endDate)) {
          $('.announcement_timer').html("Sale has ended!");
          return;
        }

        // Calculate the difference in milliseconds between now and the end date
        var diff = endDate.diff(now);

        // If countdown is over, stop
        if (diff <= 0) {
          $('.announcement_timer').html("00:00:00");
          return;
        }

        // Calculate days, hours, minutes, and seconds left
        var days = Math.floor(diff / (1000 * 60 * 60 * 24));
        var hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((diff % (1000 * 60)) / 1000);

        var displayText;

        // Logic to decide what to display based on time left
        if (days > 0) {
          displayText =
            "" +
            (days < 10 ? "0" : "") + days + ":" +
            (hours < 10 ? "0" : "") + hours + ":" +
            (minutes < 10 ? "0" : "") + minutes + ":" + 
            (seconds < 10 ? "0" : "") + seconds + " DAYS";
        } else if (hours > 0) {
          displayText =
            "" +
            (hours < 10 ? "0" : "") + hours + ":" +
            (minutes < 10 ? "0" : "") + minutes + ":" +
            (seconds < 10 ? "0" : "") + seconds + " HOURS";
        } else {
          displayText =
            "" +
            (minutes < 10 ? "0" : "") + minutes + ":" +
            (seconds < 10 ? "0" : "") + seconds + " MINUTES";
        }

        // Update the timer display
        $('.announcement_timer').html(displayText);
      }

      // Update countdown every second
      setInterval(updateCountdown, 1000);

      // Call function to show countdown immediately
      updateCountdown();
    } catch (error) {
      console.error("Error parsing promoTimer:", error);
    }
  } else {
    // If no promotime data is found, hide the timer or display a fallback message
    $('.announcement_timer').hide();
  }
});
